var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content1"},[_c('div',{staticClass:"sy-swiper",style:({
		backgroundColor: _vm.bgColor,
		height:'90vh',
		borderRadius: _vm.addUnit(_vm.radius)
	})},[(_vm.showButton)?_c('div',{staticClass:"sy-swiper__operation left",style:({
			width: _vm.addUnit(_vm.buttonSize),
			height: _vm.addUnit(_vm.buttonSize),
			background: _vm.buttonBgColor,
			fontSize: _vm.addUnit(_vm.buttonSize)
		}),on:{"click":_vm.slideLeft}},[_vm._t("left-button")],2):_vm._e(),_c('div',{staticClass:"sy-swiper__panel",on:{"touchstart":_vm.onTouchStart,"touchend":_vm.onTouchEnd}},_vm._l((_vm.images),function(item,index){return _c('div',{key:index,staticClass:"sy-swiper__panel-item",style:({
	                    transform: _vm.itemStyles[index].transform,
	                    zIndex: _vm.itemStyles[index].zIndex,
	                    opacity: _vm.itemStyles[index].opacity,
						transitionDuration: _vm.millisecondsToSeconds(_vm.duration) + 's',
						transitionTimingFunction: _vm.easing
	                })},[_c('div',{staticClass:"sy-swiper__panel-item__content",on:{"click":function($event){return _vm.$emit('click', item, index)}}},[(_vm.showFirstImageOnly)?[(_vm.itemStyles[index].isTop)?_c('img',{staticClass:"slide",style:({
							borderRadius: _vm.addUnit(_vm.slideRadius)
						}),attrs:{"src":item,"mode":_vm.imgMode}}):_c('div',{staticClass:"slide-mask",style:({ background: _vm.maskBgColor, borderRadius: _vm.addUnit(_vm.slideRadius) })})]:[_c('img',{staticClass:"slide",style:({ borderRadius: _vm.addUnit(_vm.slideRadius) }),attrs:{"src":item,"mode":_vm.imgMode}})]],2)])}),0),(_vm.showButton)?_c('div',{staticClass:"sy-swiper__operation right",style:({
			width: _vm.addUnit(_vm.buttonSize),
			height: _vm.addUnit(_vm.buttonSize),
			background: _vm.buttonBgColor,
			fontSize: _vm.addUnit(_vm.buttonSize)
		}),on:{"click":_vm.slideRight}},[_vm._t("right-button")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }